// File: ChequeBounceNotice.jsx
import React from "react";

export default function ChequeBounceNotice() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Cheque Bounce Notice
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Professional Compliance Support by Hawkins &amp; Brooks
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks provides legal support for cheque bounce notices under NI Act.
          </p>
          <p className="text-gray-700">
            Complete Section 138 legal notice drafting, 30-day demand service via registered post/speed post, 15-day payment window compliance, court complaint preparation, and recovery proceedings ensuring maximum cheque amount realization.
          </p>
        </div>

        {/* Right: Image (TOPIC-SPECIFIC: Cheque bounce legal notice NI Act) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/50988/pexels-photo-50988.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Cheque bounce notice legal support Section 138"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks ensures complete documentation for Section 138 legal notices.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Original cheque photocopy</li>
                <li>Bank return memo/dishonour advice</li>
                <li>Proof of transaction underlying cheque</li>
                <li>KYC of drawer (PAN/Aadhaar)</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              Strong legal drafting and recovery support under Section 138 NI Act.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Section 138 Notice Perfection
                </h3>
                <p className="text-gray-700 text-sm">
                  Court-compliant legal notice drafting within 30 days of cheque dishonour, registered post AD/speed post service with acknowledgment tracking, 15-day statutory demand period, debt/liability proof inclusion, and criminal prosecution threat ensuring 80% pre-litigation settlement rate.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Court Complaint Execution
                </h3>
                <p className="text-gray-700 text-sm">
                  Private complaint filing before Magistrate within 30 days post 15-day notice period, Section 138 NI Act prosecution, evidence affidavit preparation, court fee payment, summons issuance coordination, accused appearance management, and 2x cheque amount recovery with 24% compound interest.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Recovery Success Guarantee
                </h3>
                <p className="text-gray-700 text-sm">
                  Full recovery support including attachment of property/bank accounts, Section 421 CrPC execution petition, civil recovery parallel proceedings, compromise settlement facilitation, NBW issuance coordination, and debt recovery tribunal reference ensuring 95% success rate within 6-12 months.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
